import { getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createEmployeeAddedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.EMPLOYEE_ADDED,
        ...getUserAndEventTime(),
        data: {
            uri: 'https://api.atomicfi.com/employees/5d77f95207085632a58945c3',
            employerId: '642c9aa6f8fc90e0dbb4c92f',
            employeeId: '5d77f95207085632a58945c3'
        }
    };
};
//# sourceMappingURL=employee-added.js.map